import { getEOtherIncomeTypeSelectableList } from '@if/core/types'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { Grid, IconButton, Typography } from '@mui/material'
import { useMemo } from 'react'
import { Control, FieldError, FieldErrorsImpl, Merge, UseFormRegister, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputTextField, SelectComponent } from '../../../components'
import { ApplicantIncomes, ApplicantOtherIncome } from '../../../data/types'

interface Props {
  index: number
  register: UseFormRegister<ApplicantIncomes>
  formControl: Control<ApplicantIncomes>
  error: Merge<FieldError, (Merge<FieldError, FieldErrorsImpl<ApplicantOtherIncome>> | undefined)[]> | undefined
  onDelete: () => void
}

const OtherIncomeForm = ({ index, register, formControl, error, onDelete }: Props) => {
  const { t } = useTranslation()

  const typeId: number = +useWatch({
    control: formControl,
    name: `otherIncomes.${index}.typeId`,
  })

  const otherIncomeTypeOptions = useMemo(
    () =>
      getEOtherIncomeTypeSelectableList().map((value) => ({
        label: t(`EOtherIncomeType.${value}`, { ns: 'enum' }),
        value,
      })),
    [t],
  )

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid
        alignItems="center"
        alignContent="center"
        size={{
          xs: 12,
          md: 2,
        }}
      >
        <Typography variant="body1" component="div" sx={{ paddingTop: 2, paddingBottom: 2 }}>
          {`${t('editCreditApplication.income.other.other')} ${index + 1}`}:
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: typeId === 6 ? 3 : 4,
        }}
      >
        <InputTextField
          error={error ? error[index]?.annualAmount : undefined}
          label={t('editCreditApplication.income.job.annualSalary')}
          {...register(`otherIncomes.${index}.annualAmount`)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: typeId === 6 ? 3 : 5,
        }}
      >
        <SelectComponent
          error={error ? error[index]?.typeId : undefined}
          items={otherIncomeTypeOptions}
          label={t('editCreditApplication.income.job.jobType')}
          {...register(`otherIncomes.${index}.typeId`)}
        />
      </Grid>
      {typeId === 6 && (
        <Grid
          size={{
            xs: 12,
            md: 3,
          }}
        >
          <InputTextField
            label="Description"
            {...register(`otherIncomes.${index}.description`)}
            error={error ? error[index]?.description : undefined}
            maxLength={50}
          />
        </Grid>
      )}
      <Grid
        size={{
          xs: 12,
          md: 1,
        }}
      >
        <IconButton onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default OtherIncomeForm
